import { render, staticRenderFns } from "./search-calendar-event-input.vue?vue&type=template&id=4fe47d22&scoped=true&"
import script from "./search-calendar-event-input.vue?vue&type=script&lang=js&"
export * from "./search-calendar-event-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe47d22",
  null
  
)

export default component.exports